'use client';

import { c as _c } from "react/compiler-runtime";
import { TrafficOriginType } from '@cc-shopping/contracts/credit-cards-page/constants';
import { useConstant } from '@cc-shopping/hooks/useConstant';
import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { Box, type SxProps, type Theme } from '@mui/material';
import { v4 as uuid } from 'uuid';
import { MAIN_SUBNAV_ITEMS } from './constants';
import { MainSubnavItem } from './MainSubnavItem';
import { SeeAllButton } from './SeeAllButton';
import { getNavItemsForTrafficOrigin } from './utils';
type SubnavProps = {
  trafficOriginType: TrafficOriginType;
  analyticsProps: {
    entitySection: string;
  };
  activeNavId: string;
  sx?: SxProps;
};
const getVisibilityStyles = (index: number): SxProps<Theme> => ({
  display: {
    '@media (min-width: 0px)': {
      display: index < 3 ? 'block' : 'none'
    },
    '@media (min-width: 480px)': {
      display: index < 4 ? 'block' : 'none'
    },
    '@media (min-width: 600px)': {
      display: index < 5 ? 'block' : 'none'
    },
    '@media (min-width: 890px)': {
      display: index < 6 ? 'block' : 'none'
    },
    '@media (min-width: 1080px)': {
      display: 'block'
    }
  }
});
const visibilityStylesCache = Array.from({
  length: MAIN_SUBNAV_ITEMS.length
}, (_, index) => getVisibilityStyles(index));
export const Subnav = t0 => {
  const $ = _c(51);
  const {
    analyticsProps: t1,
    activeNavId,
    sx,
    trafficOriginType: t2
  } = t0;
  const {
    entitySection
  } = t1;
  const trafficOriginType = t2 === undefined ? TrafficOriginType.Organic : t2;
  const activityId = useConstant(_temp);
  let T0;
  let T1;
  let T2;
  let t10;
  let t11;
  let t12;
  let t13;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== activeNavId || $[1] !== activityId || $[2] !== entitySection || $[3] !== sx || $[4] !== trafficOriginType) {
    const mainSubnavItems = getNavItemsForTrafficOrigin(MAIN_SUBNAV_ITEMS, trafficOriginType);
    T2 = FeatureViewed;
    t10 = "cc_sub_nav";
    t11 = entitySection;
    t12 = 0;
    t13 = activityId;
    T1 = Box;
    t7 = "nav";
    t8 = "Credit card categories";
    if ($[19] !== sx) {
      t9 = {
        display: "flex",
        ...sx
      };
      $[19] = sx;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    T0 = Box;
    t3 = "ul";
    t4 = "menubar";
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        display: "flex",
        justifyContent: "space-between",
        gap: 2,
        margin: 0,
        padding: 0,
        listStyle: "none",
        width: "100%"
      };
      $[21] = t5;
    } else {
      t5 = $[21];
    }
    let t14;
    if ($[22] !== activeNavId || $[23] !== activityId) {
      t14 = (subnav, index) => <Box key={subnav.label} component="li" sx={visibilityStylesCache[index]}><MainSubnavItem analyticsProps={{
          impressionPosition: index,
          parentActivityId: activityId
        }} item={subnav} selected={activeNavId === subnav.identifier} /></Box>;
      $[22] = activeNavId;
      $[23] = activityId;
      $[24] = t14;
    } else {
      t14 = $[24];
    }
    t6 = mainSubnavItems.map(t14);
    $[0] = activeNavId;
    $[1] = activityId;
    $[2] = entitySection;
    $[3] = sx;
    $[4] = trafficOriginType;
    $[5] = T0;
    $[6] = T1;
    $[7] = T2;
    $[8] = t10;
    $[9] = t11;
    $[10] = t12;
    $[11] = t13;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    T0 = $[5];
    T1 = $[6];
    T2 = $[7];
    t10 = $[8];
    t11 = $[9];
    t12 = $[10];
    t13 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t14;
  if ($[25] !== activityId) {
    t14 = {
      featureViewedActivityId: activityId
    };
    $[25] = activityId;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== activeNavId || $[28] !== t14 || $[29] !== trafficOriginType) {
    t15 = <Box component="li"><SeeAllButton analyticsProps={t14} activeNavId={activeNavId} trafficOriginType={trafficOriginType} /></Box>;
    $[27] = activeNavId;
    $[28] = t14;
    $[29] = trafficOriginType;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== T0 || $[32] !== t15 || $[33] !== t3 || $[34] !== t4 || $[35] !== t5 || $[36] !== t6) {
    t16 = <T0 component={t3} role={t4} sx={t5}>{t6}{t15}</T0>;
    $[31] = T0;
    $[32] = t15;
    $[33] = t3;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== T1 || $[39] !== t16 || $[40] !== t7 || $[41] !== t8 || $[42] !== t9) {
    t17 = <T1 component={t7} aria-label={t8} sx={t9}>{t16}</T1>;
    $[38] = T1;
    $[39] = t16;
    $[40] = t7;
    $[41] = t8;
    $[42] = t9;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== T2 || $[45] !== t10 || $[46] !== t11 || $[47] !== t12 || $[48] !== t13 || $[49] !== t17) {
    t18 = <T2 entityName={t10} entitySection={t11} impressionPosition={t12} activityId={t13}>{t17}</T2>;
    $[44] = T2;
    $[45] = t10;
    $[46] = t11;
    $[47] = t12;
    $[48] = t13;
    $[49] = t17;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  return t18;
};
function _temp() {
  return uuid();
}